module.exports = __webpack_public_path__ + "07a016827ae277e09a2399b7a138629a.svg";